import { Component, Input, OnInit } from '@angular/core';
import { ReservationService } from "../../services/reservation.service";
import { ClosableComponent } from "../../models/closable-component";
import { BsModalRef } from "ngx-bootstrap/modal";

@Component({
  selector: 'app-daily-sum',
  templateUrl: './daily-sum.component.html',
  styleUrls: ['./daily-sum.component.scss']
})
export class DailySumComponent extends ClosableComponent implements OnInit {

  @Input() restaurant;
  @Input() startDate = new Date();
  dailySum;

  constructor(
    public bsModalRef: BsModalRef,
    private service: ReservationService) {
    super(bsModalRef);
  }

  ngOnInit(): void {
    this.getDailySum();
  }

  getDailySum() {
    this.service.getDailySum(this.restaurant.historyId, this.startDate).subscribe(result => {
      this.dailySum = result;
    });
  }

}
